import service from '../service.js'

export default{

    getFile(request_key){
        return service.get('view-attachment',{
            request_key : request_key
        })
    },
    updateCivilStatus(request_key){
        return service.post('civil-status',{
            request_key : request_key
        })
    },
}